// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"216":"dc24802b","432":"5b3f5620","787":"85725437"}[chunkId] + ".js";
};